import {useContext, useEffect, useLayoutEffect, useState} from "react";

import DeviceContext from "../../store/device-context";
import Footer from "../../components/footer/Footer";
import { isAppstore } from "../../App";
import DesktopPage from "./DesktopPage";
import Header from "../header/Header";
import MobilePage from "./MobilePage";
import ModalIsWorking from "./order/ModalIsWorking";
import ModeratorContext from "../../store/moderator-context";
import Loader from "../../components/loader/Loader";
import AuthContext from "../../store/auth-context";

const ModeratorLayout = () => {
    const [isWorking, setIsWorking] = useState(null);
    const acount = useContext(AuthContext)
    const ctx = useContext(ModeratorContext);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    
    useLayoutEffect(() => {
        if (ctx.workingHours === 404) {
            if (acount.userData?.workingHoursDay.success) {
                setIsWorking(true);
            } else {
                setIsWorking(false);
            }
        } else if (ctx.workingHours != null) {
            setIsWorking(ctx.workingHours);
        } else {
            setIsWorking(null);
        }
    }, [ctx.workingHours, acount.userData]);

    useEffect(() => {
        let timeout;

        const resetTimeout = () => {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                window.location.reload();
            }, 1200000);
        };

        const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];

        events.forEach((event) => window.addEventListener(event, resetTimeout));

        resetTimeout();

        return () => {
            clearTimeout(timeout);
            events.forEach((event) => window.removeEventListener(event, resetTimeout));
        };
    }, []);

    console.log(isWorking)

    const device = useContext(DeviceContext);
    localStorage.setItem('firstVisit', '1')
    return (
        <div className={isAppstore ? "copyBan" : undefined}>
            <Header />

            <main className="main">
                {
                    isWorking === null ? (
                        <Loader />
                    ) : isWorking ? (
                        device.isMobile ? <MobilePage /> : <DesktopPage />
                    ) : (
                        <ModalIsWorking />
                    )
                }
            </main>

            <Footer />
        </div>
    );
};

export default ModeratorLayout;
